import React from "react"
import { Link } from "react-router-dom"
import classnames from "classnames"
import navigationConfig from "../../../../../configs/navigationConfig"
import SideMenuGroup from "./SideMenuGroup"
import { Badge } from "reactstrap"
import { ChevronRight } from "react-feather"
import { history } from "../../../../../history"
import _ from "lodash"

// import { getCookie } from "../../../../../redux/actions/cookie/cookie";

class SideMenuContent extends React.Component {
  // Day la menu doc
  constructor(props) {
    super(props)

    this.parentArr = []
    this.collapsedPath = null
    this.redirectUnauthorized = () => {
      history.push("/404")
    }
  }
  state = {
    flag: true,
    isHovered: false,
    activeGroups: [],
    currentActiveGroup: [],
    tempArr: [],
    // listPermission: []
  }

  handleGroupClick = (id, parent = null, type = "") => {
    let open_group = this.state.activeGroups
    let active_group = this.state.currentActiveGroup
    let temp_arr = this.state.tempArr
    // Active Group to apply sidebar-group-active class
    if (type === "item" && parent === null) {
      active_group = []
      temp_arr = []
    } else if (type === "item" && parent !== null) {
      active_group = []
      if (temp_arr.includes(parent)) {
        temp_arr.splice(temp_arr.indexOf(parent) + 1, temp_arr.length)
      } else {
        temp_arr = []
        temp_arr.push(parent)
      }
      active_group = temp_arr.slice(0)
    } else if (type === "collapse" && parent === null) {
      temp_arr = []
      temp_arr.push(id)
    } else if (type === "collapse" && parent !== null) {
      if (active_group.includes(parent)) {
        temp_arr = active_group.slice(0)
      }
      if (temp_arr.includes(id)) {
        // temp_arr.splice(temp_arr.indexOf(id), 1)
        temp_arr.splice(temp_arr.indexOf(id), temp_arr.length)
      } else {
        temp_arr.push(id)
      }
    } else {
      temp_arr = []
    }

    if (type === "collapse") {
      // If open group does not include clicked group item
      if (!open_group.includes(id)) {
        // Get unmatched items that are not in the active group
        let temp = open_group.filter(function(obj) {
          return active_group.indexOf(obj) === -1
        })
        // Remove those unmatched items from open group
        if (temp.length > 0 && !open_group.includes(parent)) {
          open_group = open_group.filter(function(obj) {
            return !temp.includes(obj)
          })
        }
        if (open_group.includes(parent) && active_group.includes(parent)) {
          open_group = active_group.slice(0)
        }
        // Add group item clicked in open group
        if (!open_group.includes(id)) {
          open_group.push(id)
        }
      } else {
        // If open group includes click group item, remove it from open group
        open_group.splice(open_group.indexOf(id), 1)
      }
    }
    if (type === "item") {
      open_group = active_group.slice(0)
    }

    this.setState({
      activeGroups: open_group,
      tempArr: temp_arr,
      currentActiveGroup: active_group
    })
  }

  initRender = (parentArr) => {
    this.setState({
      activeGroups: parentArr.slice(0),
      currentActiveGroup: parentArr.slice(0),
      flag: false,
      // listPermission: listPermission
    })
  }

  checkPermission = (item) => {
    if (item.children && Array.isArray(item.children)) {
      return !!_.find(item.children, child => this.checkPermission(child))
    }
    if (item.children && Array.isArray(item.children)) {
      return !!_.find(item.children, child => this.checkPermission(child))
    }
    const itemRoles = item.roles
    // const userGroups = this.props.groups
    return typeof this.props.hasRole === "function" && this.props.hasRole(itemRoles)
    // var allow_render_menu_item = false
    // if (this.hasRole(this.props.userRole, item.roles) && this.props.userRole !=="normal") {
    //   allow_render_menu_item = true
    // }else if(this.props.userRole === "normal" && typeof(item.permissions)!=="undefined" && item.permissions.length){
    //   if (item.permissions !== undefined && item.permissions) {
    //     const userPermissions = this.props.userPermission
    //     const itemPermissions = item.permissions
    //     const foundPermission = _.find(userPermissions, o => (itemPermissions.includes(_.get(o, "module", "")) && _.get(o, ["access", "view"], 0) ===1 ))
    //     if (foundPermission && typeof(foundPermission) !=="undefined") {
    //       allow_render_menu_item = true
    //     }
    //   }
    // }
    // return allow_render_menu_item
  }

  // initRender = (parentArr, listPermission) => {
  //   this.setState({
  //     activeGroups: parentArr.slice(0),
  //     currentActiveGroup: parentArr.slice(0),
  //     flag: false,
  //     listPermission: listPermission
  //   })
  // }

  componentDidMount() {
    const activeParent = _.find(navigationConfig, mi => _.find(_.get(mi, 'children', []), i => {
      return i.navLink === this.props.activeItemState || i.parentOf === this.props.activeItemState
    }))
    const activeGroup = _.get(activeParent, 'id', '')
    this.initRender([activeGroup])

    // this.initRender(this.parentArr[0] ? this.parentArr[0] : [])
    // var listPermission = this.checkPermission(navigationConfig);
    // this.initRender(this.parentArr[0] ? this.parentArr[0] : [], listPermission)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.activePath !== this.props.activePath) {
      if (this.collapsedMenuPaths !== null) {
        this.props.collapsedMenuPaths(this.collapsedMenuPaths)
      }

      this.initRender(
        this.parentArr[0] ? this.parentArr[this.parentArr.length - 1] : []
      )
    }
  }
  render() {
    // Loop over sidebar items
    // eslint-disable-next-line
    const menuItems = navigationConfig.map((item, itemKey) => {
      if (typeof item.showCondition === 'function') {
        if (!item.showCondition(this.props.user)) {
          return false
        }
      }
      const CustomAnchorTag = item.type === "external-link" ? `a` : Link
      // checks if item has groupheader
      if (item.type === "groupHeader") {
        let nextGroupTitleIndex = _.findIndex(navigationConfig, (i, k) => k > itemKey && i.type === "groupHeader") || navigationConfig.length
        if (!_.filter(_.filter(navigationConfig, (i, k) => k > itemKey && k < nextGroupTitleIndex), i => this.checkPermission(i)).length) {
          return false
        } 
        return (
          <li
            className="navigation-header"
            key={`group-header-${item.groupTitle}`}
          >
            <span>{item.groupTitle}</span>
          </li>
        )
      }
      // const s = new URLSearchParams(_.get(window, ['location', 'search'], ''))
      // let isActived = false
      // if (typeof item.param !== 'undefined') {
      //   const sCheck = s.get(item.param.name, '') !== '' ? s.get(item.param.name, '') : null
      //   isActived = (item.navLink.includes(this.props.activeItemState) && item.type === "item" && sCheck === item.param.value && this.props.activeItemState !== "/")
      //
      // } else {
        // isActived = ()
      // }
      let renderItem = (
        <li
          className={classnames("nav-item", {
            "has-sub": item.type === "collapse",
            open: this.state.activeGroups.includes(item.id),
            "sidebar-group-active": this.state.currentActiveGroup.includes(
              item.id
            ),
            hover: this.props.hoverIndex === item.id,
            active: (this.props.activeItemState === item.navLink &&
            item.type === "item" ) || (this.props.activeItemState !== "/" && item.navLink && item.navLink.includes(this.props.activeItemState)),
            disabled: item.disabled
          })}
          key={item.id}
          onClick={e => {
            e.stopPropagation()
            if (item.type === "item") {
              this.props.handleActiveItem(item.navLink)
              this.handleGroupClick(item.id, null, item.type)
              if(this.props.deviceWidth <= 1200 && item.type === "item"){
                this.props.toggleMenu()
              }
            } else {
              this.handleGroupClick(item.id, null, item.type)
            }
          }}
        >
          <CustomAnchorTag
            to={item.filterBase ? item.filterBase : item.navLink && item.type === "item" ? item.navLink :  ""}
            href={item.type === "external-link" ? item.navLink : ""}
            className={`d-flex ${
              item.badgeText
                ? "justify-content-between"
                : "justify-content-start"
            }`}
            onMouseEnter={() => {
              this.props.handleSidebarMouseEnter(item.id)
            }}
            onMouseLeave={() => {
              this.props.handleSidebarMouseEnter(item.id)
            }}
            key={item.id}
            onClick={e => {
              return item.type === "collapse" ? e.preventDefault() : ""
            }}
            target={item.newTab ? "_blank" : undefined}
          >
            <div className="menu-text">
              {item.icon}
              <span className="menu-item menu-title">{item.title}</span>
            </div>

            {item.badge ? (
              <div className="menu-badge">
                <Badge color={item.badge} className="mr-1" pill>
                  {item.badgeText}
                </Badge>
              </div>
            ) : (
              ""
            )}
            {item.type === "collapse" ? (
              <ChevronRight className="menu-toggle-icon" size={13} />
            ) : (
              ""
            )}
          </CustomAnchorTag>
          {item.type === "collapse" ? (
            <SideMenuGroup
              group={item}
              handleGroupClick={this.handleGroupClick}
              activeGroup={this.state.activeGroups}
              handleActiveItem={this.props.handleActiveItem}
              activeItemState={this.props.activeItemState}
              handleSidebarMouseEnter={this.props.handleSidebarMouseEnter}
              activePath={this.props.activePath}
              hoverIndex={this.props.hoverIndex}
              initRender={this.initRender}
              parentArr={this.parentArr}
              triggerActive={undefined}
              currentActiveGroup={this.state.currentActiveGroup}
              permission={this.props.permission}
              userRole={this.props.userRole}
              redirectUnauthorized={this.redirectUnauthorized}
              collapsedMenuPaths={this.props.collapsedMenuPaths}
              toggleMenu={this.props.toggleMenu}
              deviceWidth={this.props.deviceWidth}
              hasRole={this.hasRole}
              checkPermission={this.checkPermission}
              user={this.props.user}
            />
          ) : (
            ""
          )}
        </li>
      )

      if (
        item.navLink &&
        item.collapsed !== undefined &&
        item.collapsed === true
      ) {
        this.collapsedPath = item.navLink
        this.props.collapsedMenuPaths(item.navLink)
      }
      //check role and permission before render
      const allow_render_menu_item = this.checkPermission(item)
      //check menu item type
      if (
        (item.type === "collapse" && allow_render_menu_item) || (item.type === "external-link" && allow_render_menu_item)
        || (item.type === "item" && allow_render_menu_item)
        || (item.roles === undefined && item.type !== "collapse")
      ) {
        return renderItem
      }

      return null

      // if (this.props.userRole === 'root') {
      //   return renderItem
      // }
      // // check permission here
      // if (item.permissions !== undefined && item.permissions) {
      //   // check phải có đủ permissions thì mới render
      //   // if (item.navLink === this.props.activePath) {
      //   //   return this.redirectUnauthorized()
      //   // }
      //   return null
      // }
      // return null
      // return renderItem

      // if (
      //   item.type === "collapse" || item.type === "external-link" ||
      //   (
      //     item.type === "item" &&
      //     item.roles &&
      //     item.roles.includes(this.props.userRole)
      //   ) ||
      //   item.roles === undefined
      // ) {
      //   return renderItem
      // }
      // if (
      //   item.type === "item" &&
      //   item.navLink === this.props.activePath &&
      //   !item.roles.includes(this.props.userRole)
      // ) {
      //   return this.redirectUnauthorized()
      // }
    })
    return <React.Fragment>{menuItems}</React.Fragment>
  }
}
export default SideMenuContent
